import * as React from 'react';
import { Space, Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import MLModel from '../../../ml_models/models/MLModel';
import { PromptTemplate } from '../../../prompt_templates/types';
import { PipelineStep } from './CustomBlock';
import { PipelineStepCard } from './PipelineStepCard';

interface InterpretationBlockPipelineProps {
    pipeline: PipelineStep[];
    models: MLModel[];
    promptTemplates: PromptTemplate[];
    isLoadingModels: boolean;
    isLoadingPrompts: boolean;
    disabled: boolean;
    onAddStep: () => void;
    onRemoveStep: (stepIndex: number) => void;
    onStepTypeChange: (stepIndex: number, newType: 'image' | 'text' | 'remote') => void;
    onStepFieldChange: (stepIndex: number, field: string, value: string | boolean | undefined) => void;
    onMoveStep: (dragIndex: number, hoverIndex: number) => void;
}

const InterpretationBlockPipeline: React.FC<InterpretationBlockPipelineProps> = ({
    pipeline,
    models,
    promptTemplates,
    isLoadingModels,
    isLoadingPrompts,
    disabled,
    onAddStep,
    onRemoveStep,
    onStepTypeChange,
    onStepFieldChange,
    onMoveStep
}) => {
    if (!pipeline) {
        return null;
    }
    return (
        <div className="interpretation-block-pipeline">
            <label className="custom-block-label">Pipeline Steps</label>
            <DndProvider backend={HTML5Backend}>
                <Space direction="vertical" style={{ width: '100%' }} size="small">
                    {pipeline.map((step, stepIndex) => (
                        <PipelineStepCard
                            key={stepIndex}
                            step={step}
                            stepIndex={stepIndex}
                            models={models}
                            promptTemplates={promptTemplates}
                            isLoadingModels={isLoadingModels}
                            isLoadingPrompts={isLoadingPrompts}
                            disabled={disabled}
                            onRemove={() => onRemoveStep(stepIndex)}
                            onTypeChange={newType => onStepTypeChange(stepIndex, newType)}
                            onFieldChange={(field, value) => onStepFieldChange(stepIndex, field, value)}
                            moveStep={onMoveStep}
                        />
                    ))}
                    <Button onClick={onAddStep} icon={<PlusOutlined />} disabled={disabled} size="small" block>
                        Add Pipeline Step
                    </Button>
                </Space>
            </DndProvider>
        </div>
    );
};

export default InterpretationBlockPipeline;
